module.exports = __webpack_public_path__ + "static/media/image-loader.86612673.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/image-loader.svg
// module id = 379
// module chunks = 2